import * as React from 'react';
import { PopupType, PopupActionType, sendBIUserPopupCTA } from '@src/context/actions/bi';

export interface ModalProps {
  onClose: () => void;
  onCancel: () => void;
  onOk: () => void;
}

export function withBIModalEvents(type: PopupType) {
  return function <T extends ModalProps>(Component: React.ComponentClass<T> | React.FunctionComponent<T>) {
    return class extends React.Component<Omit<T, 'onClose'>> {
      render() {
        const { props } = this;
        const componentProps = {
          ...props,
          onOk: () => {
            sendBIUserPopupCTA(type, PopupActionType.RClick);
            props.onOk();
          },
          onCancel: () => {
            sendBIUserPopupCTA(type, PopupActionType.LClick);
            props.onCancel();
          },
          onClose: () => {
            sendBIUserPopupCTA(type, PopupActionType.Close);
            props.onCancel();
          },
        } as T;

        return <Component {...componentProps} />;
      }
    };
  };
}
